import createId from "@/lib/create-id";

import type { QuickNoteSummary } from "@/types/quick-note";
import type { UserTiny } from "@/types/user";

interface CreateDraftMemoOptions {
  note: string;
  patient: UserTiny;
  creator: UserTiny;
  eventId?: string | null;
  isPinned?: boolean;
  isAlert?: boolean;
  existingMemo?: QuickNoteSummary;
}

/** Builds the single optimistic shape used for staged and API-backed memos. */
export function createDraftMemo({
  note,
  patient,
  creator,
  eventId = null,
  isPinned = false,
  isAlert,
  existingMemo,
}: CreateDraftMemoOptions): QuickNoteSummary {
  const now = new Date().toISOString();

  if (existingMemo) {
    return {
      ...existingMemo,
      note,
      isAlert: isAlert ?? existingMemo.isAlert,
      updatedDate: now,
    };
  }

  return {
    id: createId("qn"),
    patient,
    note,
    creator,
    eventId,
    createdDate: now,
    updatedDate: now,
    isArchived: false,
    isPinned,
    isAlert: isAlert ?? false,
  };
}
